import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-750253cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "register-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "register-body" }, [
    /*#__PURE__*/_createElementVNode("div", null, [
      /*#__PURE__*/_createElementVNode("h4", { class: "label-color-white" }, "Your account has been created.")
    ]),
    /*#__PURE__*/_createElementVNode("span", { class: "label-color-white" }, " We have sent a mail to your inbox. Please verify your account by clicking the link in the mail. ")
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}